import React, { useEffect, useState } from "react";

import axios from "axios";
import { server } from "../utills/utils";

import { connect } from "react-redux";
import * as actionTypes from "../store/actions/actionTypes";

import styled from "styled-components";

import Navigation from "../components/Navigations/MainNavigation";
import Skeleton from "../components/Skeletons/HomeSkeleton";
import Shop from "../components/Shops/Shop";
import NotFound from "../components/Common/NotFoundSearch";
import Footer from "../components/Footer";

const HomeContainer = styled.div`
  width: 80%;
  height: auto;
  padding-top: 100px;
  margin-left: 10%;
  @media (max-width: 768px) {
    width: 90%;
    padding-top: 80px;
    margin-left: 5%;
  }
`;
const ShopsContainer = styled.div`
  width: 103.4%;
  min-height: 70vh;
  display: flex;
  flex-flow: wrap;
  flex-direction: row;
  padding: 30px 0 60px 0;
  @media (max-width: 768px) {
    padding-top: 20px;
  }
`;
const Title = styled.h1`
  font-size: 2em;
  font-weight: 500;
  padding: 5px 0;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;
const SubTitle = styled.p`
  font-size: 1.2em;
  padding: 0;
  margin: 0;
  color: gray;
  @media (max-width: 768px) {
    font-size: 1em;
  }
`;

const TechnicalArea = styled.div`
  padding: 20px 0 0 0;
`;
const TechButton = styled.button`
  padding: 10px 30px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: gray;
  background: white;
  &:hover {
    color: black;
  }
`;
const TechActiveButton = styled.button`
  padding: 10px 30px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #276fb7;
  border-radius: 5px;
  color: gray;
  background: #276fb7;
  color: white;
`;
function Home(props) {
  const [serviceType, setServiceType] = useState("All");
  const [load, setLoad] = useState(true);
  const fetchShops = async () => {
    try {
      const shops = await axios.post(server, {
        query: `
              query{
                searchShopsActive(catId:"${localStorage.catId}",cityId:"${localStorage.cityId}",thanaId:"${localStorage.thanaId}"){
                  _id
                  name
                  location
                  cityName
                  thanaName
                  coverImage
                  userName
                  localAddress
                }
              }
            `,
      });
      console.log("All shops", shops);
      props.setShops(shops.data.data.searchShopsActive);
    } catch (error) {
      throw error;
    }
  };
  const fetchShops2 = async () => {
    try {
      const shops = await axios.post(server, {
        query: `
                query{
                  searchShopsDefault(location:"${props.location}"){
                    _id
                    name
                    location
                    cityName
                    thanaName
                    coverImage
                    userName
                    localAddress
                  }
                }
              `,
      });
      console.log(shops);
      props.setShops(shops.data.data.searchShopsDefault);
    } catch (error) {
      throw error;
    }
  };

  const serviceTypeHandler = async (type) => {
    try {
      setLoad(false);
      setServiceType(type);
      const shops = await axios.post(server, {
        query: `
              query{
                technicalServiceSearch(catId:"${localStorage.catId}",cityId:"${localStorage.cityId}",thanaId:"${localStorage.thanaId}", serviceType:"${type}"){
                  _id
                  name
                  location
                  cityName
                  thanaName
                  coverImage
                  userName
                }
              }
            `,
      });
      console.log(shops);
      props.setShops(shops.data.data.technicalServiceSearch);
      setLoad(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.cityId && localStorage.thanaId && localStorage.catId) {
      fetchShops();
    } else {
      fetchShops2();
    }
  }, []);
  return (
    <div>
      <Navigation />
      <HomeContainer>
        {localStorage.catName &&
        localStorage.cityName &&
        localStorage.thanaName ? (
          <Title>
            <span style={{ color: "#276FB7" }}>{localStorage.catName}</span>{" "}
            Shops in{" "}
            <span style={{ color: "#276FB7" }}>{localStorage.cityName}</span> ,{" "}
            <span style={{ color: "#276FB7" }}>{localStorage.thanaName}</span>{" "}
            Area
          </Title>
        ) : (
          <Title>All Shops</Title>
        )}
        {localStorage.catName &&
        localStorage.cityName &&
        localStorage.thanaName ? (
          <SubTitle>
            {props.shops ? props.shops.length : 0} shops available in this place{" "}
          </SubTitle>
        ) : (
          <SubTitle>Available shops</SubTitle>
        )}

        {localStorage.catId == "6129e467f8785a2974c9915a" && (
          <TechnicalArea>
            {serviceType == "All" ? (
              <TechActiveButton>All</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("All")}>
                All
              </TechButton>
            )}
            {serviceType == "Professional" ? (
              <TechActiveButton>Professional Service</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Professional")}>
                Professional Service
              </TechButton>
            )}
            {serviceType == "Repair" ? (
              <TechActiveButton>Repair Service</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Repair")}>
                Repair Service
              </TechButton>
            )}
          </TechnicalArea>
        )}
        {localStorage.catId == "6129e403f8785a2974c99151" && (
          <TechnicalArea>
            {serviceType == "All" ? (
              <TechActiveButton>All</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("All")}>
                All
              </TechButton>
            )}
            {serviceType == "Computer" ? (
              <TechActiveButton>Computer</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Computer")}>
                Computer
              </TechButton>
            )}
            {serviceType == "Electronics" ? (
              <TechActiveButton>Electronics</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Electronics")}>
                Electronics
              </TechButton>
            )}
          </TechnicalArea>
        )}
        {localStorage.catId == "6129e3ebf8785a2974c9914e" && (
          <TechnicalArea>
            {serviceType == "All" ? (
              <TechActiveButton>All</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("All")}>
                All
              </TechButton>
            )}
            {serviceType == "Grocerry" ? (
              <TechActiveButton>Grocerry</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Grocerry")}>
                Grocerry
              </TechButton>
            )}
            {serviceType == "Food" ? (
              <TechActiveButton>Food</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Food")}>
                Food
              </TechButton>
            )}
          </TechnicalArea>
        )}
        {localStorage.catId == "6129e40ff8785a2974c99154" && (
          <TechnicalArea>
            {serviceType == "All" ? (
              <TechActiveButton>All</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("All")}>
                All
              </TechButton>
            )}
            {serviceType == "Mobile" ? (
              <TechActiveButton>Mobile</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Mobile")}>
                Mobile
              </TechButton>
            )}
            {serviceType == "Accessories" ? (
              <TechActiveButton>Accessories</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Accessories")}>
                Accessories
              </TechButton>
            )}
          </TechnicalArea>
        )}
        {localStorage.catId == "6129e455f8785a2974c99157" && (
          <TechnicalArea>
            {serviceType == "All" ? (
              <TechActiveButton>All</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("All")}>
                All
              </TechButton>
            )}
            {serviceType == "Furniture" ? (
              <TechActiveButton>Furniture</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Furniture")}>
                Furniture
              </TechButton>
            )}
            {serviceType == "Housing" ? (
              <TechActiveButton>Housing</TechActiveButton>
            ) : (
              <TechButton onClick={() => serviceTypeHandler("Housing")}>
                Housing
              </TechButton>
            )}
          </TechnicalArea>
        )}
        <ShopsContainer>
          {props.homeLoad && load ? (
            props.shops.map((shop) => {
              return <Shop key={shop._id} shop={shop} />;
            })
          ) : (
            <Skeleton />
          )}
          {props.shops.length === 0 && props.homeLoad ? (
            <NotFound
              title="No Shop Found"
              subTitle="We are sorry! we don't found any shop related to your search."
            />
          ) : null}
        </ShopsContainer>
      </HomeContainer>
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    shops: state.utils.shops,
    location: state.utils.location,
    homeLoad: state.utils.homeLoad,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShops: (shops) => {
      dispatch({
        type: actionTypes.SET_SHOPS,
        shops,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
